var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerishable6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85521 14.73L14.751 8.84062L44.1975 38.3198L38.3017 44.2092L8.85521 14.73ZM17.6808 5.89354L23.5725 0L35.3594 11.7833L29.4677 17.6769L17.6808 5.89354ZM0 23.5756L5.8925 17.6829L17.6777 29.4681L11.785 35.3606L0 23.5756ZM0.00229167 41.67H25.0023V45.8367H0.00229167V41.67Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerishable6);
export default __webpack_public_path__ + "static/media/perishable6.16e02231406b563945d9d4c7d4a053cc.svg";
export { ForwardRef as ReactComponent };